<template>
    <a-popconfirm
        :title="$t('label.confirm')"
        @confirm="onConfirm"
        @cancel="onCancel"
        :okText="$t('label.yes')"
        :cancelText="$t('label.no')"
    >
        <a-button :type="type" :disabled="loading || disabled">
            <i class="fa fa-spin spin" v-if="!loading" />
            <i class="fa fa-trash" />
            <span v-if="!iconOnly">&nbsp; {{ $t('label.delete') }}</span>
        </a-button>
    </a-popconfirm>
</template>
<script>
export default {
    props: {
        // title: {
        //     type: String,
        //     default: this.$t('label.delete'),
        // },
        loading: {
            type: Boolean,
            default: false,
        },
        iconOnly: {
            type: Boolean,
            default: false,
        },
        // size: {
        //     type: String,
        //     default: 'default',
        // },
        type: {
            type: String,
            default: 'danger',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        onConfirm() {
            this.$emit('confirm')
        },
        onCancel() {
            this.$emit('cancel')
        },
    },
}
</script>
